module.exports = __webpack_public_path__ + "2f92ebe4fd06a25d569d04014d6511ba.pdf";